<template>
  <v-alert color="error" icon="warning" value="true">
    {{mensagem}}
  </v-alert>

</template>

<script>

export default {
  name: 'notfound',
  data () {
    return {
      mensagem: 'A página que você deseja acessar não existe.'
    }
  },
  components: {
  },
  computed: {

  },
  methods: {
  },
  created () {
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// NotFound.vue?01d25b1a